import { IHttpResponse } from "@cirrus/core/http/types"

export type i18nFunc = (key: string) => string

export type Translations = Record<string, any>

export type LanguageCode = "de-DE" | "en-GB" | "en-US" | "fr-CA" | "nl-NL"

export type AvailableLanguages = Partial<Record<LanguageCode, string>>

export class TranslationsState {
  language: LanguageCode = "en-GB"
  translations: Partial<Record<LanguageCode, Translations>> | null = null
  loading: boolean = false
  error: null | unknown = null
}

export class TranslationsContext extends TranslationsState {
  i18n = (key: string) => key
  changeLanguage = (language: LanguageCode) => console.debug(language)
}

export type TranslateArgs = {
  key: string;
  language: LanguageCode;
  translations: Translations | null
}

export interface ITranslationsService {
  translate: ({ key, language, translations }: TranslateArgs) => (any)
  getTranslations: (language: LanguageCode) => Promise<IHttpResponse<Translations | null>>
  persistLanguage: (language: LanguageCode) => void
  getDefaultLanguage: () => LanguageCode
}
